var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M345.043,256c0,22.261-39.866,77.913-89.043,77.913S166.957,278.261,166.957,256 c0-49.178,39.866-89.043,89.043-89.043S345.043,206.822,345.043,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M345.043,256c0,49.178-39.866,89.043-89.043,89.043S166.957,305.178,166.957,256"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 353.427,
    y: 319.639,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -125.4831 358.5964)",
    width: 33.391,
    height: 22.261
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 314.07,
    y: 358.994,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -164.8388 342.2935)",
    width: 33.391,
    height: 22.261
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 400.656,
    y: 366.851,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -145.034 405.8207)",
    width: 33.391,
    height: 22.261
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 361.299,
    y: 406.213,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -184.3942 389.5197)",
    width: 33.391,
    height: 22.261
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 377.04,
    y: 343.247,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -135.2602 382.2079)",
    width: 33.391,
    height: 22.261
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 337.694,
    y: 382.602,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -174.6126 365.9128)",
    width: 33.391,
    height: 22.261
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 329.544,
    y: 126.805,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 541.0344 499.9738)",
    width: 89.043,
    height: 22.261
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 314.081,
    y: 130.749,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 464.3475 476.0975)",
    width: 33.391,
    height: 22.26
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 353.427,
    y: 170.098,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 503.692 571.0911)",
    width: 33.391,
    height: 22.26
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 361.282,
    y: 83.526,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 578.3161 428.8593)",
    width: 33.391,
    height: 22.261
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 400.651,
    y: 122.879,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 617.6954 523.8765)",
    width: 33.391,
    height: 22.261
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 69.81,
    y: 386.542,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 314.6838 35.6313)",
    width: 89.043,
    height: 22.261
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 140.919,
    y: 382.6,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 324.573 3.8704)",
    width: 33.391,
    height: 22.26
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 101.569,
    y: 343.252,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 285.2246 20.1705)",
    width: 33.391,
    height: 22.261
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 117.031,
    y: 339.316,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 295.1205 -11.5916)",
    width: 89.043,
    height: 22.261
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 69.81,
    y: 103.201,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 276.0196 114.331)",
    width: 89.043,
    height: 22.261
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 93.412,
    y: 126.806,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 333.0029 137.9383)",
    width: 89.043,
    height: 22.261
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 117.038,
    y: 150.428,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 390.0373 161.557)",
    width: 89.043,
    height: 22.26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.681e9cf18457d59d54f66057fbf723f3.svg";
export { ForwardRef as ReactComponent };